import { api } from '../creat-api'
// 数据统计-今日与总量数据
export function getCountProgram (params) {
  return api({
    url: '/countProgram',
    params
  })
}
// getProgramPlayCount
// 数据分析-今日与总量数据
export function getProgramPlayCountAnalsis (params) {
  return api({
    method: 'POST',
    url: '/getProgramPlayCount',
    params
  })
}
// 数据统计-节目时长统计
export function getDurationCount (params) {
  return api({
    url: '/durationCount',
    params
  })
}
// 数据统计-节目/节目集条数统计
export function getTotalCount (params) {
  return api({
    url: '/totalCount',
    params
  })
}
// 入库节目及节目集统计
export function getPutInDate (params) {
  return api({
    url: '/getPutInDate',
    params
  })
}
// 节目、节目集分类统计
export function getCategoryCount (params) {
  return api({
    url: '/categoryCount',
    params
  })
}
// 节目、节目集条数统计-导出
export function getTotalCountExport (params) {
  return api({
    url: '/totalCountExport',
    params
  })
}
// 节目、节目集统计
export function getItemDate (params) {
  return api({
    url: '/getItemDate',
    params
  })
}
// 节目、节目集时长统计
export function getProgramTimeDate (params) {
  return api({
    url: '/getItemTime',
    params
  })
}
// 周数据统计
export function getProgramPlayByWeek (params) {
  return api({
    url: '/getProgramPlayByWeek',
    params
  })
}
// 最近7天TOP10节目集排名
export function getProgramGroupPlayRankLimit10ByWeek (params) {
  return api({
    url: '/getProgramGroupPlayRankLimit10ByWeek',
    params
  })
}
// 最近7天TOP10节目排名
export function getProgramPlayRankLimit10ByWeek (params) {
  return api({
    url: '/getProgramPlayRankLimit10ByWeek',
    params
  })
}
